
import { React, useState, useEffect, Card, Toast, Breadcrumb, CustomTable, FormModal, showDeleteOrRestoreMessage, _formatDate, Icon, Select, showCustomConfirmMessage } from "../utils/commonImports";
import { formConfigs } from "../utils/formsConfig";
import { _api } from '../auth/Api';
import { DatePicker, Alert, Button } from "antd";
import dayjs from "dayjs";
import { customStyleMd } from "../utils/common";
import { _exportToExcel } from "../helper/ExportToExcel";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [rolesDrp, setRolesDrp] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterBtnShow, setFilterBtnShow] = useState(true);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showExp, setShowExp] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState({});
  const [filters, setFilters] = useState({
    name: "",
    userEmail: "",
    contactNo: "",
    roleId: null,
    createDateto: null,
    createDateFrom: null,
  });

  useEffect(() => {
    _getUsers();
    _getRoles();
  }, []);

  const _getRoles = async () => {
    try {
      await _api("GET", "Roles/GetAllActiveRoles", null, (res) => {
        if (res.isSuccess) {
          const x = res.data?.map((i) => ({
            label: i.roleName,
            value: i.id
          }));
          setRolesDrp(x)
        }
      })
    } catch (error) {
      console.log(error?.message)
    }
  }

  const _getUsers = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    const payload = {
      name: filterValues.name || "",
      userEmail: filterValues.userEmail || "",
      contactNo: filterValues.contactNo || "",
      roleId: filterValues.roleId?.value || null,
      createdDateTo: filterValues.createDateto ? dayjs(filterValues.createDateto).format("YYYY-MM-DD") : "",
      createdDateFrom: filterValues.createDateFrom ? dayjs(filterValues.createDateFrom).format("YYYY-MM-DD") : "",
      page: {
        pageNo: pageNo,
        numberOfRecords: numberOfRecords,
      },
    };

    try {
      setLoading(true);
      await _api("POST", "PortalUser/GetActivePortalUsers", payload, (res) => {
        if (res.isSuccess) {
          setUsers(res.data);
          setTotalRecords(res.totalRecords || 0);
        } else {
          setUsers([]);
          // Toast.fire({ icon: "error", title: res.message });
        }
        setLoading(false);
      });
    } catch (error) {
      console.error(error);
      setUsers([]);
      setLoading(false);
      Toast.fire({ icon: "error", title: "Failed to fetch users" });
    }
  };

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getUsers(filters, pagination.current, pagination.pageSize);
  };

  const handleReset = () => {
    let filter = { name: "", userEmail: "", contactNo: "", roleId: null, createDateto: null, createDatetFrom: null }
    setFilters(filter);
    setShowExp(false);
    setPage(1);
    _getUsers(filter, 1, pageSize);
  };

  const handleApply = () => {
    const { name, userEmail, contactNo, roleId, createDateto, createDatetFrom } = filters;
    if (!name && !userEmail && !contactNo && !roleId && !createDateto && !createDatetFrom) {
      setShowExp(true);
      return;
    }
    setPage(1);
    _getUsers(filters, 1, pageSize);
  };

  const _saveUser = async (data) => {
    let config = { url: "", method: "POST" };
    if (data && data.id > 0) {
      config.url = "PortalUser/UpdatePortalUser";
      data.userId = data.id;
      delete data.id;
    } else {
      config.url = "PortalUser/CreatePortalUser";
    }
    try {
      await _api(config.method, config.url, data, (res) => {
        if (res.isSuccess) {
          Toast.fire({ icon: "success", title: res.message });
          setModalShow(false);
          setData({});
          _getUsers(filters, page, pageSize);
        } else {
          Toast.fire({ icon: "error", title: res.message });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const _deleteUser = async (d) => {
    const isConfirmed = await showDeleteOrRestoreMessage(d?.isActive ? "Delete" : "Restore");
    // const isConfirmed = await showConfirmMessage();
    if (isConfirmed) {
      try {
        await _api('POST', 'PortalUser/SoftDeletePortalUser', { userId: d?.id }, function (res) {
          if (res.isSuccess) {
            Toast.fire({ icon: 'success', title: res.message })
            _getUsers();
          } else {
            Toast.fire({ icon: 'error', title: res.message })
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const launchModal = (data, type) => {
    setData(data);
    setModalShow(type);
  };

  const columns = [
    {
      title: "First Name", dataIndex: "firstName", render: (_, row) => (
        <div className="d-flex flex-column">
          <span style={{ fontSize: "14px" }}>
            {row.firstName} {row.lastName}
          </span>
          <span style={{ fontSize: "12px", color: "#6c757d" }}>
            {row.roleName}
          </span>
        </div>
      )
    },
    { title: "Username", dataIndex: "userName" },
    {
      title: "Contact", dataIndex: "contactNo", render: (_, row) => (
        <div className="d-flex flex-column">
          <span style={{ fontSize: "14px" }}>
            {row.contactNo}
          </span>
          <span style={{ fontSize: "12px", color: "#6c757d" }}>
            {row.userEmail}
          </span>
        </div>
      )
    },
    { title: "Last Login", dataIndex: "lastLogin", render: (date) => _formatDate(date), },
    { title: "Last Invalid Login", dataIndex: "invalidLastLoginAttempt", render: (date) => _formatDate(date), },
    { title: "Registered On", dataIndex: "userCreatedOn", render: (date) => _formatDate(date), },
    { title: "Created By", dataIndex: "createdByName" },
    {
      title: "Is Blocked",
      dataIndex: "action",
      render: (_, record) => {
        if (record.isBlocked) {
          return (
            <div className="d-flex gap-2">
              {/* //{rights && rights?.edit && ( */}
              <Button danger title="Unblock User" icon={<Icon icon="mdi:account-lock-outline" fontSize={20} />} onClick={() => handleUnblock(record, true)} />
              {/* )} */}
            </div>
          );
        }
        return <Icon icon="mdi:account-lock-open-outline" fontSize={20} color="green" title="Active User" />;
      },
    },
    //   {
    //     title: "Created On",
    //     dataIndex: "createDate",
    //     render: (date) => _formatDate(date),
    // },
  ];

  const handleUnblock = async (user) => {
    let isYes = await showCustomConfirmMessage({ message: `Are you sure you want to unblock ${user?.firstName} ${user?.lastName}?`, icon: 'warning' }) //`${type.ic}`});
    if (isYes) {
      try {
        await _api("POST", "PortalUser/BlockUnblockUser", { userId: user?.id }, (res) => {
          if (res.isSuccess) {
            Toast.fire({ icon: "success", title: res.message });
            _getUsers();
          } else {
            Toast.fire({ icon: "error", title: res.message });
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  const xlsColumns = [
    { title: "User Id", dataIndex: "id" },
    { title: "First Name", dataIndex: "firstName" },
    { title: "Last Name", dataIndex: "lastName" },
    { title: "Username", dataIndex: "userName" },
    { title: "Email", dataIndex: "userEmail" },
    { title: "Contact No", dataIndex: "contactNo" },
    { title: "Role", dataIndex: "roleName" },
    { title: "Verified", dataIndex: "isVerified" },
    { title: "Active", dataIndex: "isActive" },
    { title: "Blocked", dataIndex: "isBlocked" },
    { title: "Created On", dataIndex: "userCreatedOn" },
    { title: "Created By", dataIndex: "createdByName" },
    { title: "Last Login", dataIndex: "lastLogin" },
  ]
  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      name: "",
      userEmail: "",
      contactNo: "",
      roleId: null,
      createdDate: "",
      page: {
        pageNo: 0,
        numberOfRecords: 0,
      },
    };

    try {
      await _api("POST", "PortalUser/GetActivePortalUsers", payload, (res) => {
        if (res.isSuccess) {
          const krDateSahe = res.data.map((x) => ({
            ...x,
            userCreatedOn: _formatDate(x.userCreatedOn),
            lastLogin: _formatDate(x.lastLogin),
            isVerified: x.isVerified ? "Yes" : "No",
            isBlocked: x.isBlocked ? "Yes" : "No",
            isActive: x.isActive ? "Yes" : "No",
          }));

          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "Portal Users",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };
  return (
    <>
      <Breadcrumb title="Users" />
      {filterBtnShow && (
        <Card className=" mb-3">
          <div className="p-2 bg-white">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  value={filters.name}
                  onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={filters.userEmail}
                  onChange={(e) => setFilters({ ...filters, userEmail: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Contact No"
                  value={filters.contactNo}
                  onChange={(e) => setFilters({ ...filters, contactNo: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <Select
                  options={rolesDrp}
                  value={filters.roleId}
                  onChange={(val) => setFilters({ ...filters, roleId: val })}
                  placeholder="Select Role"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateFrom ? dayjs(filters.createDateFrom) : null}
                  onChange={(date) => setFilters({ ...filters, createDateFrom: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.createDateto && current > dayjs(filters.createDateto)) return true;
                    return false;
                  }}
                  placeholder="Registered Date (From)"
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateto ? dayjs(filters.createDateto) : null}
                  onChange={(date) => setFilters({ ...filters, createDateto: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.createDateFrom && current < dayjs(filters.createDateFrom)) return true;
                    return false;
                  }}
                  disabled={!filters.createDateFrom}
                  placeholder="Registered Date (To)"
                />
              </div>

            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp && (
                  <Alert
                    showIcon
                    message="NOTE: Please fill at least one filter"
                    type="warning"
                  />
                )}
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setFilterBtnShow(false)}
                >
                  Hide Filter
                </button>
                <button className="btn btn-sm btn-outline-secondary" onClick={handleReset}>
                  Reset Filters
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </Card>
      )}

      <Card>
        <div className="d-flex justify-content-end gap-2" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
              style={{ lineHeight: '1.2', marginLeft: "5px" }}
            >
              Filter Users
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>
          )}
          <button
            onClick={() => launchModal({}, true)}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
          >
            Add User
            <Icon icon="mdi:plus-circle-outline" className="text-md" />
          </button>
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>

        </div>

        <CustomTable
          columns={columns}
          dataSource={users}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: users.length
          }}
          onChange={handleTableChange}
          options={{
            withActions: true,
            showEdit: true,
            showDelete: true,
            showView: false,
            rowKey: "id",
            loading: loading,
            bordered: true,
            size: "small",
            emptyText: "No Users found",
            pageKey: 5
          }}
          onEdit={(rowData) => launchModal(rowData, true)}
          onDelete={(d) => _deleteUser(d)}
        />

        <FormModal
          page="Users"
          size="lg"
          config={formConfigs.setup_users}
          selectedData={data}
          show={modalShow}
          modalshow={(d, type) => launchModal(d, type)}
          modalsave={(d) => _saveUser(d)}
        />
      </Card>
    </>
  );
};

export default Users;